import { render, staticRenderFns } from "./TopAffiliateList.vue?vue&type=template&id=68769092&"
import script from "./TopAffiliateList.vue?vue&type=script&lang=js&"
export * from "./TopAffiliateList.vue?vue&type=script&lang=js&"
import style0 from "./TopAffiliateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports